<template>
  <Layout>
    <b-row class="pb-4 pt-2">
      <b-col class="d-flex justify-content-between">
        <Button location="title" type="white" @click="handleCancel()">Voltar</Button>
        <h1 class="title">
          {{
            this.beneficio.id ? 'Códigos de Benefícios Fiscais' : 'Novo Código de Benefício Fiscal'
          }}
        </h1>
        <span />
      </b-col>
    </b-row>

    <b-card>
      <b-row class="row-padding">
        <b-col lg="5" md="12">
          <Label>Código de benefício fiscal</Label>
          <Input
            id="descricao"
            aria-required="true"
            placeholder="Código de benefício fiscal"
            v-model="beneficio.descricao"
            :error="$v.beneficio.descricao.$error"
            :mask="['XX######']"
          />
        </b-col>
        <b-col lg="3" md="12">
          <Label>% Alíq cred presumido</Label>
          <InputQuantity
            id="aliqCredPresumido"
            placeholder="% Alíq cred presumido"
            v-model="beneficio.aliqCredPresumido"
            :max="8"
            :error="$v.beneficio.aliqCredPresumido.$error"
            :precision="4"
          />
        </b-col>
      </b-row>

      <b-container class="pt-3 pb-2">
        <Label class="pb-2">CST`s que utilizam este código de benefício</Label>
        <b-row>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST00">CST 00</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST00" id="CST00" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST00">CST 02</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST02" id="CST02" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST10">CST 10</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST10" id="CST10" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST15">CST 15</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST15" id="CST15" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST20">CST 20</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST20" id="CST20" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST30">CST 30</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST30" id="CST30" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST40">CST 40</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST40" id="CST40" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST41">CST 41</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST41" id="CST41" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST50">CST 50</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST50" id="CST50" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST51">CST 51</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST51" id="CST51" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST53">CST 53</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST53" id="CST53" class="mx-2" />
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST60">CST 60</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST60" id="CST60" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST61">CST 61</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST61" id="CST61" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST70">CST 70</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST70" id="CST70" class="mx-2" />
              </div>
            </div>
          </b-col>
          <b-col md="1" lg="1" sm="12">
            <div class="form-group">
              <Label htmlFor="CST90">CST 90</Label>
              <div>
                <checkbox-switch v-model="beneficio.CST90" id="CST90" class="mx-2" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>

    <b-row class="margin-button-save text-center">
      <b-col>
        <Button type="cancel" @click="handleCancel()"> <Close class="mb-1" /> Cancelar </Button>
        <Button type="success" @click="handleSave()">Salvar</Button>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required, minLength, maxLength, between } from 'vuelidate/lib/validators';
import { getIdByLastSlash } from '@/reusable/getIdByLastSlash';
import { Layout, Input, Button, CheckboxSwitch, Label, InputQuantity } from '@/components';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';

const MAX_ALIQ_CRED_PRESUMIDO = 3.2;
const { valorUS } = FormatMixin.methods;

const validateAliqCredPresumido = (value) =>
  valorUS(value) >= 0.0 && valorUS(value) <= MAX_ALIQ_CRED_PRESUMIDO;

export default {
  name: 'beneficioFiscal',
  mixins: [FormatMixin],
  components: {
    Layout,
    Input,
    Button,
    CheckboxSwitch,
    Label,
    InputQuantity,
  },
  validations: {
    beneficio: {
      descricao: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(8),
      },
      aliqCredPresumido: { validateAliqCredPresumido },
    },
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  async mounted() {
    this.setLoading(true);
    this.setBeneficio({});

    const beneficioFiscalId = getIdByLastSlash(this.$route.fullPath);
    if (!beneficioFiscalId) return this.setLoading(false);

    this.beneficio.id = beneficioFiscalId;

    try {
      await this.getBeneficioId(this.beneficio);
    } catch (e) {
      this.$alert.error(e?.response?.data?.error_message || 'Erro ao carregar Benefícios Fiscais');
    }

    return this.setLoading(false);
  },
  computed: {
    ...mapState('beneficio', ['beneficios', 'beneficio', 'beneficioCollection']),
    ...mapState('client', ['client']),
  },
  methods: {
    ...mapActions('client', ['setClient']),
    ...mapActions('application', ['setLoading']),
    ...mapActions('beneficio', ['saveBeneficio', 'getBeneficio', 'getBeneficioId', 'setBeneficio']),
    isValidFields() {
      this.$v.$touch();

      if (this.$v.beneficio.descricao.$error) {
        return this.$alert.error('O código deve conter 8 dígitos.');
      }

      return !this.$v?.$error;
    },
    async handleSave() {
      if (!this.isValidFields()) return false;
      this.setLoading(true);

      const data = {
        descricao: this.beneficio.descricao,
        aliqCredPresumido: this.valorUS(this.beneficio.aliqCredPresumido),
        CSTCollection: {
          CST00: this.beneficio.CST00,
          CST02: this.beneficio.CST02,
          CST10: this.beneficio.CST10,
          CST15: this.beneficio.CST15,
          CST20: this.beneficio.CST20,
          CST30: this.beneficio.CST30,
          CST40: this.beneficio.CST40,
          CST41: this.beneficio.CST41,
          CST50: this.beneficio.CST50,
          CST51: this.beneficio.CST51,
          CST53: this.beneficio.CST53,
          CST60: this.beneficio.CST60,
          CST61: this.beneficio.CST61,
          CST70: this.beneficio.CST70,
          CST90: this.beneficio.CST90,
        },
      };
      if (this.beneficio.id) {
        data.id = this.beneficio.id;
      }
      try {
        await this.saveBeneficio(data);
        this.$alert.success('Código Benefício salvo com sucesso.');
        this.$router.push({ path: '/fiscal/beneficio-fiscal' });
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }

      return this.setLoading(false);
    },
    handleCancel() {
      return this.$router.push({ name: 'BeneficioFiscal' });
    },
  },
};
</script>
